import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHero from "@/components/public/PageHero";
import EmptyState from "@/components/public/EmptyState";
import CTASection from "@/components/public/CTASection";
import Reveal from "@/components/public/Reveal";
import { useLang } from "@/context/LangContext";
import { Images } from "lucide-react";

const CATS = ["ALL", "WAREHOUSE", "COFFEE BEANS", "FARM", "PROCESSING", "QUALITY CONTROL", "PACKAGING", "EXPORT", "SHIPMENT"];

export default function Gallery() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("ALL");
  const [active, setActive] = useState(null);

  useEffect(() => {
    (async () => { try { const r = await api.get("/gallery"); setItems(r.data); } catch (e) {} })();
  }, []);

  const filtered = items.filter((i) => cat === "ALL" || i.category === cat);

  return (
    <div>
      <PageHero eyebrow="Editorial Photography" title="Gallery" sub="A visual record of our coffee, warehouse and export activity." />
      <section className="mx-auto max-w-[1400px] px-4 py-14 sm:px-8 lg:px-12">
        <div className="mb-8 flex flex-wrap gap-2">
          {CATS.map((c) => (
            <button key={c} data-testid={`gallery-filter-${c.toLowerCase().replace(/ /g,'-')}`} onClick={() => setCat(c)} className={`rounded-full border px-3.5 py-1.5 font-mono text-[11px] font-semibold uppercase tracking-wider transition-colors ${cat === c ? "border-forest bg-forest text-offwhite" : "border-forest/15 bg-white text-espresso/70 hover:border-forest/40"}`}>{c}</button>
          ))}
        </div>
        {filtered.length === 0 ? (
          <EmptyState message={t("gallery.empty")} icon={Images} testId="gallery-empty" />
        ) : (
          <div className="columns-1 gap-4 sm:columns-2 lg:columns-3">
            {filtered.map((it) => (
              <Reveal key={it.id} className="mb-4 break-inside-avoid">
                <button onClick={() => setActive(it)} className="group block w-full overflow-hidden rounded-xl border border-forest/10 bg-white text-left">
                  <img src={it.image} alt={it.title || it.category} loading="lazy" className="w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  {(it.title || it.category) && (
                    <div className="p-4">
                      <div className="font-mono text-[10px] uppercase tracking-wider text-amber-brand">{it.category}</div>
                      {it.title && <div className="mt-1 font-display text-sm font-bold text-forest-dark">{it.title}</div>}
                    </div>
                  )}
                </button>
              </Reveal>
            ))}
          </div>
        )}
      </section>
      {active && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-ink/90 p-4" onClick={() => setActive(null)}>
          <div className="max-h-[90vh] max-w-3xl overflow-hidden rounded-xl bg-white" onClick={(e) => e.stopPropagation()}>
            <img src={active.image} alt={active.title} className="max-h-[70vh] w-full object-contain" />
            <div className="p-5"><div className="font-mono text-[10px] uppercase tracking-wider text-amber-brand">{active.category}</div><div className="mt-1 font-display text-lg font-bold text-forest-dark">{active.title}</div>{active.description && <p className="mt-1 font-body text-sm text-espresso/65">{active.description}</p>}</div>
          </div>
        </div>
      )}
      <CTASection />
    </div>
  );
}
